import { disablePageScroll, enablePageScroll } from 'scroll-lock';

import OptionList from '@/views/custom_select/option_list';
import Switcher from '@/views/switcher';
import asyncSweetScroll from '@/helpers/sweet_scroll';
import showModal from '@/utils/show_modal';
import { isMobile } from '@/helpers/mobile_detect';
import { animatedCollapse, animatedExpand } from '@/helpers/animated';

let nextTariffOptionList = null;

// the options are rendered into the cached snapshot of the page otherwise, and the next
// visit renders a second set of them over the first
pageUnload('agreements_show', () => {
  nextTariffOptionList?.destroy();
  nextTariffOptionList = null;
});

pageLoad('agreements_show', () => {
  const hashParams = new URLSearchParams(window.location.hash.slice(1));

  const defaultSwitcherType = $('.container-profile .b-switcher .is-active[data-switcher_type]')
    .data('switcher_type');
  new Switcher('.container-profile .b-switcher', switcherType => {
    updateSwitcherTypeAnchor(switcherType, defaultSwitcherType);
  });

  if (hashParams.get('switcher_type') === 'info') {
    $('.b-switcher .inner .btn-info').click();
  }

  $('.close-agreement a').on('click', () => {
    $('.b-switcher .inner .btn-info').click();
    asyncSweetScroll('.agreement-close-info');
  });

  $('.pin .skud-password').on('click', ({ currentTarget }) => {
    const $mask = $(currentTarget).find('.mask');
    const $value = $(currentTarget).find('.value');
    $mask.toggleClass('hidden');
    $value.toggleClass('hidden');
  });

  initModalStorageUsageRules();
  initModalNextTariff();
  initModalTariffChanged(hashParams);

  $('.bill-info').on('click', ({ currentTarget, target }) => {
    if (target.tagName === 'BUTTON' || target.tagName === 'A') { return; }

    if (currentTarget.classList.contains('is-expanded')) {
      animatedCollapse(currentTarget.nextSibling);
      currentTarget.classList.remove('is-expanded');
    } else {
      animatedExpand(currentTarget.nextSibling);
      currentTarget.classList.add('is-expanded');
    }
  });
});

pageLoad('agreements_closing', () => {
  initModalStorageUsageRules();
  $('input.confirm').on('change', ({ currentTarget }) => {
    const $checkbox = $(currentTarget);
    const $submit = $('#submit_agreement');
    $submit.prop('disabled', !$checkbox.prop('checked'));
  });
});

function updateSwitcherTypeAnchor(switcherType, defaultSwitcherType) {
  updateHashParam('switcher_type', switcherType === defaultSwitcherType ? null : switcherType);
}

function updateHashParam(name, value) {
  const hashParams = new URLSearchParams(window.location.hash.slice(1));

  if (value) {
    hashParams.set(name, value);
  } else {
    hashParams.delete(name);
  }

  const hash = hashParams.toString();
  const url = window.location.pathname + window.location.search;

  history.replaceState(null, '', hash ? `${url}#${hash}` : url);
}

function initModalNextTariff() {
  const $modal = $('.b-modal-next-tariff');
  if (!$modal.length) { return; }

  const modal = showModal({
    $modal,
    $trigger: $('a.change-tariff'),
    isHiddenCheck: () => !$modal.hasClass('is-active'),
    show() {
      disablePageScroll();
      $modal.addClass('is-active');
    },
    hide() {
      enablePageScroll();
      $modal.removeClass('is-active');
    }
  });

  $modal.find('.modal-shade').on('click', modal.hide);
  $modal.find('.modal-close').on('click', modal.hide);

  const $select = $modal.find('select[name="tariff_months_next"]');

  // the options are drawn by the same module the custom select draws its dropdown with,
  // only rendered open — the list of the modal has no dropdown chrome
  nextTariffOptionList = new OptionList({
    $select,
    $container: $modal.find('.b-tariff-options'),
    isHtml: true
  });

  $select.on('change', ({ currentTarget }) => {
    if (!isMobile()) { return; }

    const form = currentTarget.closest('form');

    if (form.requestSubmit) {
      form.requestSubmit();
    } else {
      form.submit();
    }
  });
}

function initModalTariffChanged(hashParams) {
  const $modal = $('.b-modal-tariff.is-tariff-changed');
  if (!$modal.length) { return; }
  if (!hashParams.get('tariff_changed')) { return; }

  const modal = showModal({
    $modal,
    isHiddenCheck: () => !$modal.hasClass('is-active'),
    show() {
      disablePageScroll();
      $modal.addClass('is-active');
    },
    hide() {
      enablePageScroll();
      $modal.removeClass('is-active');
      updateHashParam('tariff_changed', null);
    }
  });

  $modal.find('.modal-shade').on('click', modal.hide);
  $modal.find('.modal-close').on('click', modal.hide);

  modal.show();
}

function initModalStorageUsageRules() {
  $('a.storage-usage-rules').on('click', () => {
    disablePageScroll();
    window.scrollTo(0, 0);
    $('.b-modal-storage-usage-rules').removeClass('hidden');
  });

  $('a.modal-close').on('click', () => {
    enablePageScroll();
    $('.b-modal-storage-usage-rules').addClass('hidden');
  });
}
